import * as React from 'react';
import BaseTypography from 'core/components/typography/BaseTypography';

export default function ShowMoreComponent({
	hide,
	value,
	showMoreFunc,
	variant,
	length,
	translate,
}) {
	return (
		<>
			{hide && value ? value.substring(0, length ?? 100) : value}
			{hide && value.length > (length ?? 100) && (
				<>
					{value.length > (length ?? 100) ? '... ' : ' '}
					<BaseTypography
						component="span"
						variant={variant || 'b1_regular'}
						styles={{ color: 'colors.rainbowBlue', cursor: 'pointer' }}
						onClick={showMoreFunc}
						translate={translate}
					>
						show more
					</BaseTypography>
				</>
			)}
		</>
	);
}
